import React from "react";

const LeadersVoice = () => {
  return (
    <section className='container my-5 home-leadership-section'>
      <div className='home-leadership-card'>
        <div className='row align-items-center g-4'>
          <div className='col-lg-4'>
            <div className='home-leadership-image-wrap'>
              <div className='home-leadership-avatar'>
                <i className='bi bi-person-fill' />
              </div>
            </div>
          </div>
          <div className='col-lg-8'>
            <span className='website-section-kicker'>Leadership Message</span>
            <p className='website-section-title-leader mb-2'>
              Leadership shaped by accountability, quality workmanship, and
              clear communication.
            </p>
            <p className='home-leadership-role mb-3'>
              CEO & Managing Director, Dialin24
            </p>
            <p className='mb-3'>
              We approach every project with practical planning, disciplined
              execution, and a strong commitment to earning long-term client
              trust.
            </p>
            <p className='mb-4'>
              Our commitment is simple: deliver dependable work, maintain
              transparency at every stage, and ensure each project reflects the
              standards our clients expect from a professional construction
              partner.
            </p>
            <div className='row g-3'>
              <div className='col-sm-4'>
                <div className='home-leadership-point'>
                  <strong>Quality First</strong>
                  <span>
                    Execution with durable materials and close supervision.
                  </span>
                </div>
              </div>
              <div className='col-sm-4'>
                <div className='home-leadership-point'>
                  <strong>Clear Updates</strong>
                  <span>
                    Transparent communication from planning to handover.
                  </span>
                </div>
              </div>
              <div className='col-sm-4'>
                <div className='home-leadership-point'>
                  <strong>Client Focus</strong>
                  <span>
                    Solutions aligned with budget, timeline, and project needs.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadersVoice;
